import { render, staticRenderFns } from "./brandlist.vue?vue&type=template&id=89ba00ce"
import script from "./brandlist.vue?vue&type=script&lang=js"
export * from "./brandlist.vue?vue&type=script&lang=js"
import style0 from "./brandlist.vue?vue&type=style&index=0&id=89ba00ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports